import * as React from 'react';
import { AccentButton } from '../controls/AccentButton';
import { AccentSpinner } from '../controls/AccentSpinner';
import { AccentComboUnbound } from '../controls/unbound/AccentComboUnbound';
import { accentUtils, t } from '../services/HelperService';
import { AccentDialog } from './AccentDialog';
import { documentTemplateTypes } from '../services/TemplateService';

export class CopyDocumentTemplateAsDlg extends React.Component {

    constructor(props) {
        super(props)


        this.state = {
            type: null,
            data:null
        };

        this.allowOk = this.allowOk.bind(this);
        this.getBody = this.getBody.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.onClose = this.onClose.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.onChanged = this.onChanged.bind(this);


    }

    onChanged(e) {
        this.setState({ type: e });

    }

    componentDidMount() {


        const types = (this.props.fromType === documentTemplateTypes.jobReview || this.props.fromType === documentTemplateTypes.installer)
            ? [
                { ID: documentTemplateTypes.installer, Description: t(documentTemplateTypes.installer) },
                { ID: documentTemplateTypes.jobReview, Description: t(documentTemplateTypes.jobReview) },
            ] : [
                { ID: documentTemplateTypes.quote, Description: t(documentTemplateTypes.quote) },
                { ID: documentTemplateTypes.orderConfirmation, Description: t(documentTemplateTypes.orderConfirmation) },
                { ID: documentTemplateTypes.invoice, Description: t(documentTemplateTypes.invoice) },
                { ID: documentTemplateTypes.statement, Description: t(documentTemplateTypes.statement) },
                { ID: documentTemplateTypes.jobSummary, Description: t(documentTemplateTypes.jobSummary) },
            ];

        this.setState({
            data: types
        });

    }

    getTitle() {
        return t("application_strings.views.documentTemplateListView.copyAsType");
    }

    allowOk() {
        return !accentUtils.isEmpty(this.state.type);
    }

    onClose(e) {
        this.props.onClose({ type: this.state.type });        
    }

    getBody() {

        if (accentUtils.isNull(this.state.data)) return <AccentSpinner />;


        return <div className="center">

            <AccentComboUnbound displayField="Description" valueField="ID" onChange={this.onChanged} label="application_strings.views.documentTemplateListView.copyAsType" data={this.state.data} />

        </div>;
    }

    render() {


        return <AccentDialog
            headerContent={this.getTitle()}
            onClose={this.props.onClose}
            actionsContent={[<AccentButton key="k1" tagName="selectTypeOk" disabled={ !this.allowOk()} onClick={this.onClose}>{t("application_strings.application.buttons.close")}</AccentButton>]}
        >
            { this.getBody()}
        </AccentDialog>

    }

}